import React, { useRef, useState } from 'react';
import { Unplug } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from '../ui/dialog';
import { Button } from '../ui/button';
import { siteApi } from '../admin/siteApi';

export const DisconnectKickDialog = ({ connection, onClose, onDisconnected }) => {
  const [busy, setBusy] = useState(false), [error, setError] = useState('');
  const pending = useRef(false);
  const disconnect = async () => {
    if (pending.current) return;
    pending.current = true; setBusy(true); setError('');
    try {
      const data = await siteApi('/account/kick/disconnect', { method: 'POST', body: JSON.stringify({ confirmed: true, kick_user_id: connection.kick_user_id }) });
      onDisconnected(data); onClose();
    } catch (failure) { setError(failure.message); }
    finally { pending.current = false; setBusy(false); }
  };
  return <Dialog open onOpenChange={(open) => { if (!open && !pending.current) onClose(); }}><DialogContent className="discord-disconnect-dialog kick-disconnect-dialog" data-testid="kick-disconnect-dialog" onInteractOutside={(e) => e.preventDefault()}>
    <DialogTitle data-testid="kick-disconnect-title">Disconnect Kick?</DialogTitle>
    <DialogDescription data-testid="kick-disconnect-description">@{connection.kick_username} will no longer earn Kick rewards here. Your existing V-Credits and login stay unchanged.</DialogDescription>
    {error && <p className="settings-error" role="alert" data-testid="kick-disconnect-error">{error}</p>}
    <div className="discord-dialog-actions"><Button variant="outline" disabled={busy} onClick={onClose} data-testid="kick-disconnect-cancel">Cancel</Button><Button variant="destructive" disabled={busy} onClick={disconnect} data-testid="kick-disconnect-confirm"><Unplug size={16} />{busy ? 'Disconnecting…' : 'Disconnect'}</Button></div>
  </DialogContent></Dialog>;
};